class blogFilter extends HTMLElement {
  constructor() {
    super();
    this.toggleBtns = this.querySelectorAll('.filter__toggle');
    this.filterOptions = this.querySelectorAll('[data-filter-option]');
    this.activeFiltersEle = document.querySelectorAll('#activeFilters a');
    this.openDrawerBtns= document.querySelectorAll('[data-openFilterDrawer]'),
    this.parentNodeblog = document.getElementById('blogfilters')
    this.submtBtn = this.querySelector('[data-applyFilters]');
    this.checkedValues = '';
    this.catClearEle = this.querySelectorAll('[data-reset-filters]');
    this.submtBtns = this.querySelectorAll('[data-submit-btn]');
  }
  
  connectedCallback() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
    this.toggleBtns?.forEach(ele => {
      ele.addEventListener('click', this.toggleDropDown.bind(this));
    })
    if(window.innerWidth >= 992) {
      // this.filterOptions?.forEach(opt => {
      //   opt.addEventListener('change', this.handleChange.bind(this));
      // });

      this.submtBtns?.forEach(btn => {
        btn.addEventListener('click', this.handleChange.bind(this));
      });
    }else {
      this.submtBtn.addEventListener('click', this.handleChange.bind(this));
    }
    this.activeFiltersEle?.forEach(ele => {
      ele.addEventListener('click', this.removeActiveFilters.bind(this));
    });

    if(this.openDrawerBtns.length > 0){
      this.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    }
    this.querySelectorAll('[data-closefilter]')?.forEach((btn) => {
      btn.addEventListener('click', this.toggleFilterDrawer.bind(this));
    })
    
    this.querySelectorAll('[data-back]')?.forEach((ele) => {
      ele.addEventListener('click',(e)=>{
        e.preventDefault();
        e.target.closest('.filter__block')?.classList.remove('open')
        e.target.closest('.filter__container')?.classList.remove('open')
      })
    })
    this.catClearEle?.forEach(ele => {
      ele.addEventListener('click', this.clearCatFilters.bind(this));
    })
  }

  handleClickOutside(event) {
    const openFilterContainers = document.querySelectorAll('.filter__container.open');

    openFilterContainers.forEach(container => {
      if (!container.contains(event.target)) {
        const toggleFilterBtn = container.querySelector('.filter__toggle');
        if (toggleFilterBtn) {
          this.closeFilterBlock(toggleFilterBtn);
        }
      }
    });
  }

  handleChange(e) {
    e.preventDefault();
    let activeTags = Array.from(this.filterOptions).filter(input => input.checked).map(input => input.value);
    let url = this.createURL(activeTags);
    this.renderData(url);
  }

  clearCatFilters(evt) {
    evt.preventDefault();
    let url = evt.currentTarget.href;
    if(evt.currentTarget.dataset.resetFilters != '') {
      let excludeData = evt.currentTarget.dataset.resetFilters.split(',');
      let activeTags = Array.from(this.filterOptions).filter(input => input.checked && !excludeData.some(exclude => input.value.includes(exclude))).map(input => input.value);
      url = this.createURL(activeTags);
    }
    this.renderData(url);
  }

  removeActiveFilters(e) {
    e.preventDefault();
    this.renderData(e.currentTarget.href);
  }

  createURL(tags) {
    let currentUrl = new URL(location.href);
    let basePath = currentUrl.pathname;
    let finalUrl;
  
    if (basePath.includes('/tagged')) basePath = basePath.split('/tagged')[0];
  
    if (Array.isArray(tags) && tags.length > 0) {
      let concatTags = tags.join('+').replace(' ', '-');
      finalUrl = `${basePath}/tagged/${concatTags}`;
    } else {
      finalUrl = basePath;
    }
    return finalUrl;
  }

  renderData(finalUrl) {
    fetch(finalUrl)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Network response was not ok: ${res.statusText}`);
        }
        return res.text();
      })
      .then(data => {
        let html = new DOMParser().parseFromString(data, 'text/html');
        
        let mainContent = document.querySelector('#MainContent');
        mainContent.innerHTML = html.querySelector('#MainContent').innerHTML;

        let allMatchDiv = document.querySelectorAll('.article-card .card-body');
        allMatchDiv.forEach(matchDiv => {
            const targetHeight = matchDiv.querySelector('.excerpt-content')?.offsetHeight;
            if (targetHeight) {
              matchDiv.style.setProperty('--bs-contnt-height', targetHeight + 'px');
            }
        });
        
        this.querySelector('[data-closefilter]')?.click();

        history.replaceState({ finalUrl }, '', finalUrl);
      })
      .catch(error => console.error('Fetch error:', error));
  }

  /**
   * Toggle Filter Block
   * @param {element} toggleFilterBtn
   */
  toggleDropDown(e) {
    e?.preventDefault();
    const toggleFilterBtn = e.currentTarget;
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    const isOpen = filterContainer.classList.contains('open');
    isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
  }
  /**
   * Open Filter Block
   * @param {element} toggleFilterBtn 
   */
  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', true);
    document.querySelectorAll('.filter__container').forEach((ele)=>{
      ele.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', false);
      Utility.toggleElement(ele, 'close');
    })
    Utility.toggleElement(filterContainer, 'open');
    Utility.trapFocus(filterContainer);
  }

  /**
   * Close Filter Block
   * @param {element} toggleFilterBtn 
   */
  closeFilterBlock(toggleFilterBtn) {
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }


  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer'){
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      this.parentNodeblog?.classList.add('filter-active');

      Utility.trapFocus(this.parentNodeblog);
      Utility.forceFocus(this.parentNodeblog?.querySelector('[data-closeFilter]'));
      
      document.querySelector('body').classList.add('scroll-fixed');
      document.body.style.overflowY = "hidden";
    }else{
      this.parentNodeblog?.classList.remove('filter-active');
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }
      if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(this.parentNodeblog);
      setTimeout(() => {
        document.querySelector('body').classList.remove('scroll-fixed');
        document.body.style.overflowY = "auto";
      }, 550);

      document.querySelectorAll('[data-filtertype] .filter__container').forEach((ele)=>{
        if (!ele.querySelector('price-range')) {
          ele.classList.remove('open');
        }
      })
      this._closeSortByDrawer();
    }
  }

  _closeSortByDrawer(){
    document.querySelector('custom-select.sort-active')?.classList.remove('sort-active');
    siteOverlay.prototype.hideOverlay();
  }
}
customElements.define('blog-filter', blogFilter);